import React from 'react';
import { LoggingErrorBoundary } from '@chr/common-javascript-logging-error-boundary';
import { ErrorPage } from './common/components/errors/ErrorPage';
import { HashRouter, useLocation } from 'react-router-dom';
import { AppRoutes } from './AppRoutes';
import { Header } from './common/components/headers/Header';
import { Footer } from './common/components/footer/Footer';
import { ChrThemeProvider } from '@chr/eds-react';
import { AnalyticsProvider } from '@chr/react-analytics';
import { Box, useTheme, useMediaQuery } from '@mui/material';

export interface AppProps {
  config: AppConfig;
}

const AppContent = () => {
  const location = useLocation();
  const isHome = location.pathname === '/';
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down('md'));

  const backgroundImage = isMobileScreen
    ? `url('./svg/mobile-background.svg')`
    : `url('./svg/background.svg')`;

  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        ...(isHome && {
          backgroundColor: '#00A3E0',
          backgroundImage,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }),
      }}
    >
      <AppRoutes />
      <Footer />
    </Box>
  );
};

export const App = ({ config }: AppProps) => {
  return (
    <AnalyticsProvider scriptSrc={config.adobeAnalyticsPath}>
      <ChrThemeProvider>
        <LoggingErrorBoundary render={ErrorPage}>
          <HashRouter>
            <Header config={config} />
            <AppContent />
          </HashRouter>
        </LoggingErrorBoundary>
      </ChrThemeProvider>
    </AnalyticsProvider>
  );
};

export default App;
